import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SfoUiJSONSchema7 } from '../../metadata.model';
import { RenderMode } from '../types/view.types';
import { NgFor, NgTemplateOutlet, NgIf, TitleCasePipe } from '@angular/common';
import { MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';
import { PresetMenuComponent } from '../preset-menu/preset-menu.component';
import { DynamicFieldComponent } from '../form-fields/dynamic-field.component';

@Component({
    selector: 'sfo-quicksettings-view',
    templateUrl: './quicksettings.component.html',
    styleUrls: ['./quicksettings.component.scss'],
    imports: [
        NgFor,
        MatExpansionPanel,
        MatExpansionPanelHeader,
        MatExpansionPanelTitle,
        NgTemplateOutlet,
        PresetMenuComponent,
        DynamicFieldComponent,
        NgIf,
        TitleCasePipe,
    ],
})
export class QuickSettingsComponent {
  @Input() schema: SfoUiJSONSchema7 | null;
  @Input() aFormControl: FormGroup;
  @Input() renderMode: RenderMode | undefined;

  get controlsInOrder(): string[] {
    const allControls = Object.keys(this.aFormControl.controls);
    return allControls.filter(key => {
      const property = this.schema?.properties?.[key] as any;
      return !property?._ui_hide;
    });
  }

  getFormControl(control: string): FormGroup {
    return this.aFormControl.get(control) as FormGroup;
  }
}
